import { render, staticRenderFns } from "./follow2.vue?vue&type=template&id=468538fc&scoped=true"
import script from "./follow2.vue?vue&type=script&lang=js"
export * from "./follow2.vue?vue&type=script&lang=js"
import style0 from "./follow2.vue?vue&type=style&index=0&id=468538fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468538fc",
  null
  
)

export default component.exports